$("select[id^=employee_title]").on('change', function(e)
{
	var selection = e.target.value
	if (selection == "Other...") {
		$("#other_title_input").toggle(500);
	}
	else
	{
		$("#employee_other_title").val(null);
		$("#other_title_input").hide(500);
	}
});

$("select[id=employee_staff_level]").on('change', function(e)
{
	var selection = e.target.value
	$("input[type=checkbox][value="+selection+"]").prop('checked',true)
});

$("input[id^=employee_computer]").on('change', function(e)
{
	var selection = e.target.value
	if (selection.includes("Desktop")) {
		$("#employee_carrying_case_input").hide(500);
		$("[name='employee[carrying_case]']").each(function (i,v) {
			v.checked=false;
		})
	}
	else
	{
		$("#employee_carrying_case_input").show(500);
	}
	if (selection.includes("Lenovo P")) {
		$("input[type=checkbox][value^=Lenovo]").prop('checked',true)
	}
});

$("#onboarding-2").on("submit", function(e) {
	if (document.getElementById("employee_initials").value.length != 3) {
		alert("Employee initials with length of 3 are required for the onboarding process.  Please talk to HR to confirm unique employee initials.");
	if (document.getElementById("employee_timesheet_approver").value === '')
		alert("Employee timesheet approver is required.");
		return false;
	}
})